(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@alifd/next"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "@alifd/next"], factory);
	else if(typeof exports === 'object')
		exports["WorkflowComps"] = factory(require("react"), require("@alifd/next"));
	else
		root["WorkflowComps"] = factory(root["React"], root["Next"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__) {
return 